import { Component, ViewEncapsulation } from '@angular/core';
import { DynamicTranslations } from 'src/locale/dynamicTranslations';
import { MyTicketsMobileComponent } from '../../my-tickets-mobile/my-tickets-mobile.component';

@Component({
  selector: 'app-my-tickets-mobile-v2',
  templateUrl: './my-tickets-mobile-v2.component.html',
  styleUrls: ['./my-tickets-mobile-v2.component.less'],
  encapsulation: ViewEncapsulation.None
})

export class MyTicketsMobileV2Component extends MyTicketsMobileComponent {
  public dynamicTranslations = DynamicTranslations;
  expandDetails = false;
  expandedTicketId: number;

  expandTicketDetail(ticketId: number) {
    if (this.expandedTicketId === ticketId) {
      this.expandedTicketId = null;
    } else {
      this.expandedTicketId = ticketId;
    }
  }

  getSportName(sportId: number) {
    return this.utilityService.getSportIcon(sportId);
  }
}
